var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomCreditCard3 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1B7690",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.443 28.072v-3.164c0-3.61-3.085-6.572-6.942-6.572H15.09c-3.814 0-6.943 2.92-6.943 6.572v3.164c0 .325.257.568.6.568H70.8c.343 0 .643-.243.643-.568zM8.147 33.645v20.607c0 3.72 3.084 6.772 6.938 6.772h49.42c3.812 0 6.938-3.01 6.938-6.772V33.645a.579.579 0 0 0-.6-.585H8.748c-.343-.042-.6.25-.6.585zm15.803 15.8c0 1.045-.9 1.923-1.97 1.923h-1.97c-1.07 0-1.97-.878-1.97-1.923v-1.922c0-1.045.9-1.923 1.97-1.923h1.97c1.07 0 1.97.878 1.97 1.923v1.922z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomCreditCard3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-credit-card-3.59878d684c649bfff50139f488ea137d.svg";